module.exports = __webpack_public_path__ + "static/media/icasino_web.959bf12f.png";